// Rotacao: quem esta em quadra a cada minuto de jogo.
//
// Isto e o coracao tatico do basquete -- no futebol o tecnico escala 11 e faz 5
// trocas; aqui ele distribui 240 minutos entre 8 a 10 atletas, e faltas podem
// tirar um titular do jogo. O motor decide a cada `ROTATION.segmentSeconds`.
//
// O modelo: cada atleta tem `targetMinutes`. A cada decisao, entra quem esta
// mais ATRASADO em relacao ao que deveria ter jogado ate aqui. Isso faz os
// minutos convergirem para o alvo sem precisar de um plano rigido, e sobrevive
// a expulsao por faltas (o tempo do expulso se redistribui sozinho).

import { ROTATION } from './tuning.js';

const GROUP = { ARM: 'per', AA: 'per', ALA: 'ala', AP: 'gar', PIV: 'gar' };
const GROUP_TARGET = { per: 2, ala: 1, gar: 2 };

/**
 * @param {Array} squad atletas com { position, targetMinutes }
 * @param {Array} state paralelo a squad: { seconds, fouls, available }
 * @param {number} elapsedFraction fracao do jogo ja decorrida (0..1)
 * @param {number} bestBias 0 = respeita a minutagem; 1 = joga com os melhores
 *   (prorrogacao, e no futuro os minutos finais de um jogo apertado)
 * @returns {number[]} indices dos 5 em quadra
 */
export function pickLineup(squad, state, elapsedFraction, bestBias = 0) {
  const eligible = [];
  for (let i = 0; i < squad.length; i++) {
    const st = state[i];
    if (st.fouls >= ROTATION.maxFouls) continue;
    if (st.available === false) continue;
    eligible.push(i);
  }
  // Cenario extremo (muita falta + lesao): joga com quem sobrou, mesmo com
  // falta demais. Nunca devolver menos de 5 -- o laco de posse conta com 5.
  if (eligible.length < 5) {
    const fallback = squad.map((_, i) => i)
      .sort((a, b) => state[a].fouls - state[b].fouls || squad[b].overall - squad[a].overall);
    return fallback.slice(0, 5);
  }

  const deficit = new Map();
  for (const i of eligible) {
    const expected = (squad[i].targetMinutes || 0) * 60 * elapsedFraction;
    deficit.set(i, expected - state[i].seconds);
  }

  const chosen = [];
  const groupCount = { per: 0, ala: 0, gar: 0 };
  while (chosen.length < 5) {
    let best = -1;
    let bestScore = -Infinity;
    for (const i of eligible) {
      if (chosen.includes(i)) continue;
      const group = GROUP[squad[i].position] || 'ala';
      // Penaliza estourar a cota do grupo: evita escalar 5 pivos so porque os
      // pivos estavam atrasados na minutagem.
      const over = Math.max(0, groupCount[group] + 1 - GROUP_TARGET[group]);
      // Um atleta a uma falta de sair vale menos em quadra: o tecnico o
      // protege para te-lo no fim do jogo. E o que qualquer banco faz, e e o
      // que impede o time de perder o titular no terceiro quarto.
      const risco = state[i].fouls >= ROTATION.maxFouls - 1 ? ROTATION.foulRiskPenalty : 0;
      const score = deficit.get(i)
        - over * ROTATION.positionBonus * 60
        - risco
        + bestBias * (squad[i].overall - 75) * 120;
      if (score > bestScore) {
        bestScore = score;
        best = i;
      }
    }
    if (best < 0) break;
    chosen.push(best);
    groupCount[GROUP[squad[best].position] || 'ala'] += 1;
  }
  return chosen;
}
